// import React, { useState } from "react";
// import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
// import {
//   AiOutlineDashboard,
//   AiOutlineUser,
//   AiOutlinePaperClip,
//   AiFillHdd,
// } from "react-icons/ai";
// import { FaBusinessTime, FaBlogger, FaPhotoVideo } from "react-icons/fa";
// import { RiKakaoTalkLine } from "react-icons/ri";
// import { MdFeedback } from "react-icons/md";
// import { BiPodcast, BiSolidBusiness } from "react-icons/bi";
// import { MdComputer, MdOutlinePoll } from "react-icons/md";
// // import { Outlet } from "react-router-dom";
// import { IoIosContact } from "react-icons/io";
// import { PiStudent } from "react-icons/pi";
// import { Layout, Menu, theme } from "antd";
// import { logoutAccess } from "../../store/stateFunctions";
// import { useNavigate } from "react-router-dom";
// import { Button } from "@mui/material";
// import { FcBusinessman } from "react-icons/fc";
// import { GoOrganization } from "react-icons/go";

// import { CiBoxList } from "react-icons/ci";

// const { Sider, Content } = Layout;

// const Sidebar = ({ role }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const {
//     token: { colorBgContainer },
//   } = theme.useToken();
//   const navigate = useNavigate();

//   return (
//     <>
//       <div className="col-md-8 text-center">
//         {/* <h5>Welcome To The Nashik Municipal Corporation, Nashik</h5> */}
//       </div>
//       <div className="col-md-2 text-end">
//         <Button
//           variant="contained"
//           color="error"
//           className=" fw-bold"
//           onClick={() => logoutAccess("Super Admin")}
//         >
//           Logout
//         </Button>
//       </div>
//       <Sider
//         trigger={null}
//         collapsible
//         collapsed={collapsed}
//         width={300}
//         style={{
//           position: "fixed",
//           height: "100%",
//           left: 0,
//           top: 0,
//           overflowY: "auto",
//           zIndex: 1000,
//         }}
//       >
//         <div style={{ height: "100%" }}>
//           <div className="logo text-center">
//             <p className="text-white   mb-0 float-end fs-4">
//               {/* <span className="sm-logo">DC</span> */}
//               {/* <span className="lg-logo">My Profile</span> */}
//               {React.createElement(
//                 collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
//                 {
//                   className: "trigger",
//                   onClick: () => setCollapsed(!collapsed),
//                 }
//               )}
//             </p>
//           </div>
//           <Menu
//             theme="light"
//             mode="inline"
//             defaultSelectedKeys={["dashboard"]}
//             onClick={({ key }) => {
//               if (key === "signout") {
//               } else {
//                 navigate(key);
//               }
//             }}
//             items={[
//               {
//                 key: "dashboard",
//                 icon: <AiOutlineDashboard className="fs-4" />,
//                 label: "Dashboard",
//               },
//               // {
//               //   key: "manageuser",
//               //   icon: <AiOutlineUser className="fs-4" />,
//               //   label: "Manage Users",
//               // },
//               {
//                 key: "postinternships ",
//                 icon: <PiStudent className="fs-4" />,
//                 label: "Students",
//                 children: [
//                   {
//                     key: "totaljobapplications",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Total Job Applications",
//                   },
//                   {
//                     key: "totalinternshipapplications",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Total Internship Applications",
//                   },
//                   {
//                     key: "students",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Total Students  ",
//                   },
//                   {
//                     key: "becomeambassador",
//                     icon: <FaBlogger className="fs-4" />,
//                     label: "Become Ambassador",
//                   },
//                   {
//                     key: "studentfeedbacks",
//                     icon: <AiOutlineUser className="fs-4" />,
//                     label: "Student Feedbacks",
//                   },
//                 ],
//               },

//               {
//                 key: "Advertise With Us",
//                 icon: <FaBusinessTime className="fs-4" />,
//                 label: "Industry",
//                 children: [
//                   {
//                     key: "newsfromindustry",
//                     icon: <AiOutlinePaperClip className="fs-4" />,
//                     label: "News",
//                   },
//                   {
//                     key: "pollsfromindustry",
//                     icon: <MdOutlinePoll className="fs-4" />,
//                     label: "Polls",
//                   },
//                   {
//                     key: "talksfromindustry",
//                     icon: <RiKakaoTalkLine className="fs-4" />,
//                     label: "Talks",
//                   },

//                   {
//                     key: "eventsfromindustry",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Events",
//                   },
//                   {
//                     key: "industryevententries",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Event Registrations",
//                   },
//                   {
//                     key: "blogsfromindustry",
//                     icon: <FaBlogger className="fs-4" />,
//                     label: "Blogs",
//                   },
//                   {
//                     key: "podcastfromindustry",
//                     icon: <BiPodcast className="fs-4" />,
//                     label: "Podcasts",
//                   },
//                   {
//                     key: "ideasfromindustry",
//                     icon: <AiOutlinePaperClip className="fs-4" />,
//                     label: "Innovations",
//                   },

//                   {
//                     key: "feedbacksfromindustryusers",
//                     icon: <MdFeedback className="fs-4" />,
//                     label: "Feedbacks",
//                   },
//                   {
//                     key: "addorganizationdetails",
//                     icon: <GoOrganization className="fs-4" />,
//                     label: "Add Organization Details",
//                   },
//                   {
//                     key: "organizationentries",
//                     icon: <GoOrganization className="fs-4" />,
//                     label: "Organization Details",
//                   },
//                   {
//                     key: "totalindustryusers",
//                     icon: <AiOutlineUser className="fs-4" />,
//                     label: "Total Industry User",
//                   },
//                   {
//                     key: "internshipsfromindustry",
//                     icon: <MdComputer className="fs-4" />,
//                     label: "Received Internships",
//                   },
//                   {
//                     key: "jobsfromindustry",
//                     icon: <BiSolidBusiness className="fs-4" />,
//                     label: " Received Jobs",
//                   },
//                   {
//                     key: "internshipapplications",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Internships Applications",
//                   },
//                   {
//                     key: "jobapplications",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Job Applications",
//                   },

//                   {
//                     key: "advertisementfromindustry",
//                     icon: <FaBlogger className="fs-4" />,
//                     label: "Industry Advertisement",
//                   },
//                 ],
//               },
//               {
//                 key: "merchantslist ",
//                 icon: <FcBusinessman className="fs-4" />,
//                 label: "Merchants",
//                 children: [
//                   {
//                     key: "addmerchant",
//                     icon: <AiOutlineUser className="fs-4" />,
//                     label: "Add Merchant Business",
//                   },
//                   {
//                     key: "merchantslist",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Merchant Businesses",
//                   },

//                   {
//                     key: "merchantenquiries",
//                     icon: <CiBoxList className="fs-4" />,
//                     label: "Merchant Enquiries",
//                   },
//                 ],
//               },
//               {
//                 key: "",
//                 icon: <AiFillHdd className="fs-4" />,
//                 label: "Yuvasarthi Admin",
//                 children: [
//                   {
//                     key: "addevents",
//                     icon: <AiFillHdd className="fs-4" />,
//                     label: "Events",
//                   },
//                   {
//                     key: "addtalks",
//                     icon: <RiKakaoTalkLine className="fs-4" />,
//                     label: "Talks",
//                   },
//                   {
//                     key: "addnews",
//                     icon: <AiOutlinePaperClip className="fs-4" />,
//                     label: "News",
//                   },
//                   {
//                     key: "addblogs",
//                     icon: <FaBlogger className="fs-4" />,
//                     label: "Blogs",
//                   },
//                   {
//                     key: "addpolls",
//                     icon: <MdOutlinePoll className="fs-4" />,
//                     label: "Polls",
//                   },
//                   {
//                     key: "addpodcasts",
//                     icon: <BiPodcast className="fs-4" />,
//                     label: "Podcasts",
//                   },
//                   {
//                     key: "addslider",
//                     icon: <FaPhotoVideo className="fs-4" />,
//                     label: "Add Slider",
//                   },
//                   {
//                     key: "postjobs",
//                     icon: <BiSolidBusiness className="fs-4" />,
//                     label: "Post Jobs",
//                   },
//                   {
//                     key: "postinternships",
//                     icon: <MdComputer className="fs-4" />,
//                     label: "Post Internships",
//                   },
//                   {
//                     key: "yuvasarathieventenquiries",
//                     icon: <IoIosContact className="fs-4" />,
//                     label: "Event Enquiries",
//                   },
//                   {
//                     key: "contactentries",
//                     icon: <IoIosContact className="fs-4" />,
//                     label: "Contact Form Entries",
//                   },
//                 ],
//               },
//             ]}
//           />
//         </div>
//       </Sider>
//     </>
//   );
// };

// export default Sidebar;

import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlinePaperClip,
  AiFillHdd,
} from "react-icons/ai";
import { FaBusinessTime, FaBlogger, FaPhotoVideo } from "react-icons/fa";
import { RiKakaoTalkLine } from "react-icons/ri";
import { MdFeedback } from "react-icons/md";
import { BiPodcast, BiSolidBusiness } from "react-icons/bi";
import { MdComputer, MdOutlinePoll } from "react-icons/md";
// import { Outlet } from "react-router-dom";
import { IoIosContact } from "react-icons/io";
import { PiStudent } from "react-icons/pi";
import { Layout, Menu } from "antd";
import { logoutAccess } from "../../store/stateFunctions";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { FcBusinessman } from "react-icons/fc";
import { GoOrganization } from "react-icons/go";

import { CiBoxList } from "react-icons/ci";

const { Sider, Content } = Layout;

const Sidebar = ({ role }) => {
  // const {
  //   token: { colorBgContainer },
  // } = theme.useToken();
  const navigate = useNavigate();

  return (
    <div>
      <div className="row banner p-3">
        <div className="col-md-2">
          <a
            className="p-2 rounded-3 border border-bottom border-2 border-dark shadow"
            data-bs-toggle="offcanvas"
            href="#offcanvasExample"
            role="button"
            aria-controls="offcanvasExample"
            id="side"
          >
            <i className="bi bi-list" />
          </a>
        </div>
        <div className="col-md-8 text-center">
          {/* <h5>Welcome To The Nashik Municipal Corporation, Nashik</h5> */}
        </div>
        <div className="col-md-2 text-end">
          <Button
            variant="contained"
            color="error"
            className=" fw-bold"
            onClick={() => logoutAccess("Super Admin")}
          >
            Logout
          </Button>
        </div>
      </div>
      <ul className="nav">
        <li className="nav-item" id="sidebarm">
          <div
            className="offcanvas offcanvas-start"
            style={{ width: "20rem" }}
            tabIndex={-1}
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header banner text-white ">
              <p id="size" className="fs-4">
                Marathwada
              </p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body ">
              <Sider width={300} style={{ height: "100vh" }}>
                <div style={{ height: "100%" }}>
                  <Menu
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={["dashboard"]}
                    onClick={({ key }) => {
                      if (key === "signout") {
                      } else {
                        navigate(key);
                      }
                    }}
                    items={[
                      {
                        key: "dashboard",
                        icon: <AiOutlineDashboard className="fs-4" />,
                        label: "Dashboard",
                      },
                      // {
                      //   key: "manageuser",
                      //   icon: <AiOutlineUser className="fs-4" />,
                      //   label: "Manage Users",
                      // },
                      // {
                      //   key: "postinternships ",
                      //   icon: <PiStudent className="fs-4" />,
                      //   label: "Citizens",
                      //   children: [
                      //     {
                      //       key: "totaljobapplications",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Total Job Applications",
                      //     },
                      //     {
                      //       key: "totalinternshipapplications",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Total Internship Applications",
                      //     },
                      //     {
                      //       key: "students",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Total Citizens  ",
                      //     },
                      //     // {
                      //     //   key: "becomeambassador",
                      //     //   icon: <FaBlogger className="fs-4" />,
                      //     //   label: "Become Ambassador",
                      //     // },
                      //     {
                      //       key: "studentfeedbacks",
                      //       icon: <AiOutlineUser className="fs-4" />,
                      //       label: "Citizen Feedbacks",
                      //     },
                      //   ],
                      // },

                      // {
                      //   key: "Advertise With Us",
                      //   icon: <FaBusinessTime className="fs-4" />,
                      //   label: "Industry",
                      //   children: [
                      //     {
                      //       key: "newsfromindustry",
                      //       icon: <AiOutlinePaperClip className="fs-4" />,
                      //       label: "News",
                      //     },
                      //     {
                      //       key: "pollsfromindustry",
                      //       icon: <MdOutlinePoll className="fs-4" />,
                      //       label: "Polls",
                      //     },
                      //     {
                      //       key: "talksfromindustry",
                      //       icon: <RiKakaoTalkLine className="fs-4" />,
                      //       label: "Talks",
                      //     },

                      //     {
                      //       key: "eventsfromindustry",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Events",
                      //     },
                      //     {
                      //       key: "industryevententries",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Event Registrations",
                      //     },
                      //     {
                      //       key: "blogsfromindustry",
                      //       icon: <FaBlogger className="fs-4" />,
                      //       label: "Blogs",
                      //     },
                      //     {
                      //       key: "podcastfromindustry",
                      //       icon: <BiPodcast className="fs-4" />,
                      //       label: "Podcasts",
                      //     },
                      //     {
                      //       key: "ideasfromindustry",
                      //       icon: <AiOutlinePaperClip className="fs-4" />,
                      //       label: "Innovations",
                      //     },

                      //     {
                      //       key: "feedbacksfromindustryusers",
                      //       icon: <MdFeedback className="fs-4" />,
                      //       label: "Feedbacks",
                      //     },
                      //     // {
                      //     //   key: "allshareideas",
                      //     //   icon: <GoOrganization className="fs-4" />,
                      //     //   label: "Students Ideas ",
                      //     // },
                      //     {
                      //       key: "addorganizationdetails",
                      //       icon: <GoOrganization className="fs-4" />,
                      //       label: "Add Organization Details",
                      //     },
                      //     {
                      //       key: "organizationentries",
                      //       icon: <GoOrganization className="fs-4" />,
                      //       label: "Organization Details",
                      //     },
                      //     {
                      //       key: "totalindustryusers",
                      //       icon: <AiOutlineUser className="fs-4" />,
                      //       label: "Total Industry User",
                      //     },
                      //     {
                      //       key: "internshipsfromindustry",
                      //       icon: <MdComputer className="fs-4" />,
                      //       label: "Received Internships",
                      //     },
                      //     {
                      //       key: "jobsfromindustry",
                      //       icon: <BiSolidBusiness className="fs-4" />,
                      //       label: " Received Jobs",
                      //     },
                      //     {
                      //       key: "internshipapplications",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Internships Applications",
                      //     },
                      //     {
                      //       key: "jobapplications",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Job Applications",
                      //     },

                      //     {
                      //       key: "advertisementfromindustry",
                      //       icon: <FaBlogger className="fs-4" />,
                      //       label: "Industry Advertisement",
                      //     },
                      //   ],
                      // },
                      // {
                      //   key: "merchantslist ",
                      //   icon: <FcBusinessman className="fs-4" />,
                      //   label: "Merchants",
                      //   children: [
                      //     {
                      //       key: "addmerchant",
                      //       icon: <AiOutlineUser className="fs-4" />,
                      //       label: "Add Merchant Business",
                      //     },
                      //     {
                      //       key: "merchantslist",
                      //       icon: <AiFillHdd className="fs-4" />,
                      //       label: "Merchant Businesses",
                      //     },

                      //     {
                      //       key: "merchantenquiries",
                      //       icon: <CiBoxList className="fs-4" />,
                      //       label: "Merchant Enquiries",
                      //     },
                      //   ],
                      // },
                      {
                        key: "addevents",
                        icon: <AiFillHdd className="fs-4" />,
                        label: "Events",
                      },
                      // {
                      //   key: "addtalks",
                      //   icon: <RiKakaoTalkLine className="fs-4" />,
                      //   label: "Talks",
                      // },
                      {
                        key: "addnews",
                        icon: <AiOutlinePaperClip className="fs-4" />,
                        label: "News",
                      },
                      {
                        key: "addblogs",
                        icon: <FaBlogger className="fs-4" />,
                        label: "Blogs",
                      },
                      {
                        key: "addtestimonials",
                        icon: <MdOutlinePoll className="fs-4" />,
                        label: "Testimonials",
                      },
                      {
                        key: "addprograms",
                        icon: <MdOutlinePoll className="fs-4" />,
                        label: "Programs",
                      },
                      {
                        key: "addgallery",
                        icon: <MdOutlinePoll className="fs-4" />,
                        label: "Gallery",
                      },
                      {
                        key: "membershipregistrations",
                        icon: <MdOutlinePoll className="fs-4" />,
                        label: "Membership registration",
                      },
                      // {
                      //   key: "addpodcasts",
                      //   icon: <BiPodcast className="fs-4" />,
                      //   label: "Podcasts",
                      // },
                      {
                        key: "addslider",
                        icon: <FaPhotoVideo className="fs-4" />,
                        label: "Add Slider",
                      },
                      {
                        key: "postjobs",
                        icon: <BiSolidBusiness className="fs-4" />,
                        label: "Post Jobs",
                      },
                      {
                        key: "postinternships",
                        icon: <MdComputer className="fs-4" />,
                        label: "Post Internships",
                      },
                      {
                        key: "yuvasarathieventenquiries",
                        icon: <IoIosContact className="fs-4" />,
                        label: "Event Enquiries",
                      },
                      {
                        key: "contactentries",
                        icon: <IoIosContact className="fs-4" />,
                        label: "Contact Form Entries",
                      },
                    ]}
                  />
                </div>
              </Sider>
            </div>
          </div>
        </li>
      </ul>

      <Content
        style={{
          // margin: "24px 16px",
          padding: 22,
          // minHeight: 280,
        }}
      >
        {/* <Outlet /> */}
      </Content>
    </div>
  );
};

export default Sidebar;
